import React, { useState, useEffect, useRef } from 'react';
import { Toast } from 'primereact/toast';
import { translatedMessage } from '../../service/LanguageService';
import { Checkbox } from 'primereact/checkbox';
import SecurityService from '../../service/SecurityService';
import { Button } from 'primereact/button';
import CompetitionUtils from '../../utilities/CompetitionUtils';
import CompetitionWorkSeniorityEditDialog from './CompetitionWorkSeniorityEditDialog';

const CompetitionWorkSeniorityComponent = (props) => {
    const [competition, setCompetition] = useState(null);
    const [hasEditPermission, setHasEditPermission] = useState(false);
    const [editDialogVisible, setEditDialogVisible] = useState(false);

    const toast = useRef(null);

    useEffect(() => {
        const checkEditPermission = async () => {
            setHasEditPermission(await SecurityService.check('CAN_EDIT_JOB_COMPETITION', props?.competition?.id));
        };

        const getCompetition = async () => {
            // console.log(props?.competition);
            setCompetition(props?.competition);
        };

        getCompetition();
        checkEditPermission();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props?.competition]);

    const showEditDialog = () => {
        setEditDialogVisible(true);
    };

    const afterSave = (savedCompetition, success, error) => {
        if (success) {
            setCompetition(savedCompetition)
            if (typeof props.afterSave === 'function') {
                props.afterSave(savedCompetition);
            }
            toast?.current?.show({ severity: 'success', summary: translatedMessage('generic.save.success') });
        } else {
            toast?.current?.show({ severity: 'error', summary: translatedMessage(error), life: 5000 });
        }
    };

    return (
        <>
            <Toast ref={toast} />

            <div className='col-12 flex flex-row align-items-center mt-5'>
                <h5 className='mb-0'>{translatedMessage('competition.requirements.work')}</h5>
                <div>
                    <Button
                        label={translatedMessage('generic.edit')}
                        icon="pi pi-pencil"
                        className="pcn-button-slim-with-icon p-button-primary ml-3"
                        onClick={showEditDialog}
                        visible={hasEditPermission && !props.readOnly}
                        disabled={!CompetitionUtils.canEdit(competition)}
                    />
                </div>
            </div>
            <div className='col-12 flex flex-row align-items-center'>
                <div className="field-checkbox text-left mb-0">
                    <Checkbox inputId="workSeniorityRequired" name="workSeniorityRequired" checked={competition?.workSeniorityRequired} disabled />
                    <label htmlFor="workSeniorityRequired">{translatedMessage("competition.requirements.work.info") + ": " + 
                        (competition?.workSeniority !== null ? competition?.workSeniority : "-")}</label>
                </div>                
            </div>

            {editDialogVisible &&
                <CompetitionWorkSeniorityEditDialog
                    value={competition}
                    visible={editDialogVisible}
                    afterSave={afterSave}
                    visibleSetter={() => setEditDialogVisible(false)}
                />
            }
        </>
    );
};

export default CompetitionWorkSeniorityComponent;
